
import {
  computed,
  watch,
  defineComponent,
  ref,
  nextTick,
} from '@nuxtjs/composition-api'

type imageType = {
  idx: string
  size: string
  type: string
  url: string
}

export default defineComponent({
  head: {},
  name: 'ItemImageGrid',
  props: ['imageGridData', 'productImage'],
  components: {},
  setup(props) {
    const zoomImageData = ref({} as imageType)
    const showZoomImageDiv = ref(false)
    const lightboxRef = ref<HTMLElement | null>(null)

    const fullImageGridData = computed((): imageType[] => {
      return (
        [
          {
            idx: 'main_product_image',
            url: props.productImage,
            type: 'image',
            size: 'large',
          },
        ] as imageType[]
      ).concat(props.imageGridData.images as imageType[])
    })

    const nextImage = () => {
      let lastImage =
        fullImageGridData.value[fullImageGridData.value.length - 1]
      for (const image of fullImageGridData.value) {
        if (lastImage.url === zoomImageData.value.url) {
          zoomImage(image)
        } else {
          lastImage = image
        }
      }
    }

    const lastImage = () => {
      let lastImage =
        fullImageGridData.value[fullImageGridData.value.length - 1]
      for (const image of fullImageGridData.value) {
        if (image.url === zoomImageData.value.url) {
          zoomImage(lastImage)
        } else {
          lastImage = image
        }
      }
    }

    const zoomImage = (image: object | boolean) => {
      if (typeof image === 'object') {
        showZoomImageDiv.value = true
        zoomImageData.value = image as imageType
      } else {
        showZoomImageDiv.value = false
        zoomImageData.value = {} as imageType
      }
    }

    /* watch for changes in showZoomImageDiv and focus on lightboxRef to make it accessible for keyboard */
    watch(showZoomImageDiv, (newVal) => {
      if (newVal) {
        nextTick(() => {
          setTimeout(() => {
            if (lightboxRef.value) {
              lightboxRef.value.focus()
            }
          }, 50)
        })
      }
    })

    return {
      zoomImage,
      showZoomImageDiv,
      zoomImageData,
      fullImageGridData,
      nextImage,
      lastImage,
    }
  },
})
